/**
 * Adzuki _document.js
 * Global document-level data bindings.
 */

(function Document($, Adzuki)
{
	"use strict";

	// disable disabled element click handlers
	$(document).on('click', '.disabled', function disabled(e) {
		e.preventDefault();
		return false;
	});

	// text truncation/expansion
	$(document).on('click', '.string-expand-collapse', function truncate()
	{
		var $self      = $(this),
		    id         = $self.data("id"),
		    $expanded  = $('#expanded_' + id),
		    $collapsed = $('#collapsed_' + id);

		if ($expanded.css('display') === 'none') {
			$collapsed.hide();
			$expanded.show();
			$self.attr('src', Adzuki.base_uri + '/adzuki/images/expand.gif');
		} else {
			$collapsed.show();
			$expanded.hide();
			$self.attr('src', Adzuki.base_uri + '/adzuki/images/collapse.gif');
		}
	});

	$(document).on('click', '.collapse-control', function truncate()
	{
		var $self = $(this),
		    id    = $self.data('target'),
		    $el   = $('#' + id);

		if ($el.length < 1) {
			console.log('element with an id of "' + id + '" does not exist in order to expand/collapse');
			return;
		}

		$self.toggleClass('plus');
		$self.toggleClass('minus');
		$el.collapse('toggle');
	});


	$(document).on('click', '.nav-additional .print', function printPage(e)
	{
		e.preventDefault();

		window.print();
	});
}(jQuery, window.Adzuki || {}));
